var productInfoHeaders;

window.addEventListener('DOMContentLoaded', function() {
  productInfoHeaders = document.querySelectorAll('.product-dropdown-info__headers .header button');
  
  // When any header button is activated, show its respective panel and collapse all other panels.
  productInfoHeaders.forEach(function(productInfoHeader) {
    productInfoHeader.addEventListener('click', function(event) {
      
      // Close all other headers
      productInfoHeaders.forEach(function(otherProductInfoHeader) {
        if(productInfoHeader != otherProductInfoHeader) {
          closePanel(otherProductInfoHeader);
        }
      });
      
      // Toggle this header/panel
      togglePanel(productInfoHeader);
    });
  });
});

function openPanel(productInfoHeader) {
  productInfoHeader.setAttribute('aria-expanded', true);
  $('#' + productInfoHeader.getAttribute('aria-controls')).slideDown();
  productInfoHeader.classList.add("active");
}

function closePanel(productInfoHeader) {
  productInfoHeader.setAttribute('aria-expanded', false);
  $('#' + productInfoHeader.getAttribute('aria-controls')).slideUp();
  productInfoHeader.classList.remove("active");
}

function togglePanel(productInfoHeader) {
  var isExpanded = productInfoHeader.getAttribute('aria-expanded') == 'true' ? true : false;
 
  if(isExpanded) {
    closePanel(productInfoHeader);
  } else {
    openPanel(productInfoHeader);
  }
}

$( document ).ready(function() {
  $('.product-dropdown-info__panels #panel-1').slideToggle();
  $('.product-dropdown-info__headers .header [aria-controls="panel-1"]').toggleClass('active');
});